import {
  Button,
  Card,
  InlineError,
  Form,
  SkeletonBodyText,
  Box,
} from '@shopify/polaris'
import React from 'react'

import CodeEditor from '../../../../components/CodeEditor'

function AdvancedSettings({ form }) {
  return (
    <Form onSubmit={form.submit}>
      <div
        style={{
          padding: 'var(--p-space-400) var(--p-space-400) var(--p-space-400) 0',
          position: 'relative',
        }}
      >
        {form.fields.jsonEditor.error && (
          <InlineError message={form.fields.jsonEditor.error} />
        )}
        <CodeEditor
          onChange={form.fields.jsonEditor.onChange}
          loading={
            <Box padding={'400'}>
              <SkeletonBodyText lines={20} />
            </Box>
          }
          value={form.fields.jsonEditor.value}
          mode={'json'}
          height={500}
        />

        <div
          style={{
            paddingLeft: 'var(--p-space-400)',
          }}
        >
          <Button
            submit
            loading={form.submitting}
            variant="primary"
            size="large"
          >
            Save
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default AdvancedSettings
